export default {
  "content": "<path d=\"M4.793 6.207L14.586 16H7v2h10a1 1 0 001-1V7h-2v7.586L6.207 4.793 4.793 6.207z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};